import React, { useEffect, useState } from "react";
import query from "jquery";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useVendorAuth } from "../context/VendorAuthContext";
import { useCart } from "../context/CartContext";
import { containsProfanity } from "../helper/profanityFilter";


const HeaderTwo = ({ category }) => {
  const [scroll, setScroll] = useState(false);
  const navigate = useNavigate();
  const { isAuthenticated, logout, user } = useAuth();
  const { isVendorAuthenticated, logoutVendor, vendor } = useVendorAuth();
  const { cartCount } = useCart();

  const handleLogout = () => { logout(); navigate("/account-login"); };
  const handleLogoutVendor = () => { logoutVendor(); navigate("/vendor-login"); };

  useEffect(() => {
    window.onscroll = () => {
      if (window.pageYOffset < 150) {
        setScroll(false);
      } else if (window.pageYOffset > 150) {
        setScroll(true);
      }
      return () => (window.onscroll = null);
    };
    const selectElement = query(".js-example-basic-single");
    selectElement.select2();

    return () => {
      if (selectElement.data("select2")) {
        selectElement.select2("destroy");
      }
    };
  }, []);

  const [menuActive, setMenuActive] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const handleMenuClick = (index) => { setActiveIndex(activeIndex === index ? null : index); };
  const handleMenuToggle = () => { setMenuActive(!menuActive); };

  const [activeSearch, setActiveSearch] = useState(false);
  const handleSearchToggle = () => { setActiveSearch(!activeSearch); };

  const [searchInput, setSearchInput] = useState('');
  const [searchCategory, setSearchCategory] = useState('');
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const q = searchInput.trim();
    if (containsProfanity(q)) return;
    navigate('/shop', { state: { searchQuery: q || undefined, category: searchCategory || undefined } });
  };

  const [activeCategory, setActiveCategory] = useState(false);
  const handleCategoryToggle = () => { setActiveCategory(!activeCategory); };
  const [activeIndexCat, setActiveIndexCat] = useState(null);
  const handleCatClick = (index) => { setActiveIndexCat(activeIndexCat === index ? null : index); };

  return (
    <>
      <style>{`
        /* ===== HeaderTwo Modern Styles ===== */

        .hdr2-bar {
          background: linear-gradient(135deg, #79bcf0 0%, #4da8e8 100%) !important;
          box-shadow: 0 2px 20px rgba(77, 168, 232, 0.3);
        }

        .hdr2-search-pill {
          display: flex;
          align-items: center;
          background: rgba(255, 255, 255, 0.13);
          border: 1.5px solid rgba(255, 255, 255, 0.3);
          border-radius: 50px;
          overflow: hidden;
          backdrop-filter: blur(6px);
          transition: border-color 0.2s, background 0.2s;
          min-width: 741px;
          height: 46px;
        }
        .hdr2-search-pill:focus-within {
          border-color: rgba(255, 255, 255, 0.6);
          background: rgba(255, 255, 255, 0.2);
        }

        .hdr2-cat-select {
          background: transparent;
          border: none !important;
          border-right: 1.5px solid rgba(255, 255, 255, 0.22) !important;
          color: rgba(255, 255, 255, 0.92) !important;
          padding: 0 14px 0 16px;
          outline: none;
          font-size: 13px;
          font-weight: 500;
          cursor: pointer;
          height: 100%;
          appearance: none;
          -webkit-appearance: none;
          min-width: 130px;
        }
        .hdr2-cat-select option {
          background: #0d2756;
          color: #fff;
        }

        .hdr2-search-pill .select2-container {
          min-width: 140px !important;
          height: 100%;
        }
        .hdr2-search-pill .select2-container .select2-selection--single {
          background: transparent !important;
          border: none !important;
          border-right: 1.5px solid rgba(255,255,255,0.22) !important;
          border-radius: 0 !important;
          height: 46px !important;
          display: flex;
          align-items: center;
          padding: 0 14px 0 16px;
        }
        .hdr2-search-pill .select2-container .select2-selection--single .select2-selection__rendered {
          color: rgba(255,255,255,0.92) !important;
          font-size: 13px;
          font-weight: 500;
          padding: 0;
          line-height: normal;
        }
        .hdr2-search-pill .select2-container .select2-selection--single .select2-selection__arrow {
          top: 50%;
          transform: translateY(-50%);
          right: 10px;
        }
        .hdr2-search-pill .select2-container .select2-selection--single .select2-selection__arrow b {
          border-color: rgba(255,255,255,0.7) transparent transparent transparent;
        }

        .hdr2-search-input {
          flex: 1;
          background: transparent;
          border: none;
          color: #fff;
          padding: 0 14px;
          outline: none;
          font-size: 14px;
          height: 100%;
          min-width: 0;
        }
        .hdr2-search-input::placeholder {
          color: rgba(255, 255, 255, 0.5);
        }

        .hdr2-search-btn {
          background: rgba(37, 117, 252, 0.85);
          border: none;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 16px;
          cursor: pointer;
          margin: 5px;
          flex-shrink: 0;
          transition: background 0.2s, transform 0.15s;
        }
        .hdr2-search-btn:hover {
          background: #2575fc;
          transform: scale(1.08);
        }

        .hdr2-icon-btn {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 3px;
          padding: 7px 10px;
          border-radius: 10px;
          color: rgba(255, 255, 255, 0.88);
          text-decoration: none;
          background: transparent;
          border: none;
          cursor: pointer;
          transition: background 0.2s, color 0.2s;
        }
        .hdr2-icon-btn:hover {
          background: rgba(255, 255, 255, 0.14);
          color: #fff;
          text-decoration: none;
        }
        .hdr2-icon-symbol {
          font-size: 28px;
          line-height: 1;
        }
        .hdr2-icon-label {
          font-size: 11px;
          font-weight: 500;
          letter-spacing: 0.3px;
          white-space: nowrap;
          color: inherit;
        }
        .hdr2-cart-wrap {
          position: relative;
          display: inline-flex;
        }
        .hdr2-cart-badge {
          position: absolute;
          top: -5px;
          right: -7px;
          min-width: 17px;
          height: 17px;
          background: #ff4757;
          color: #fff;
          border-radius: 50%;
          font-size: 10px;
          font-weight: 700;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid #4da8e8;
          padding: 0 2px;
          line-height: 1;
        }

        .hdr2-nav-bar {
          background: #fff !important;
          border-bottom: 1px solid #e5e9ef !important;
          box-shadow: 0 2px 14px rgba(0, 0, 0, 0.055) !important;
        }

        .hdr2-purchase-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: #a8d4f5;
          color: #1a3a6b !important;
          padding: 10px 22px;
          border-radius: 8px;
          font-weight: 600;
          font-size: 14px;
          text-decoration: none;
          border: none;
          cursor: pointer;
          transition: background 0.2s, box-shadow 0.2s;
          white-space: nowrap;
          letter-spacing: 0.2px;
        }
        .hdr2-purchase-btn:hover {
          background: #8ec8f2;
          box-shadow: 0 4px 14px rgba(100, 181, 246, 0.4);
          color: #1a3a6b !important;
          text-decoration: none;
        }

        .hdr2-nav-link {
          color: #374151 !important;
          font-weight: 500;
          font-size: 16px;
          letter-spacing: 0.1px;
          position: relative;
          transition: color 0.15s;
        }
        .hdr2-nav-link::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          height: 2px;
          background: #2575fc;
          border-radius: 2px;
          transform: scaleX(0);
          transition: transform 0.2s ease;
        }
        .hdr2-nav-link:hover {
          color: #2575fc !important;
        }
        .hdr2-nav-link:hover::after,
        .hdr2-nav-link.activePage::after {
          transform: scaleX(1);
        }
        .hdr2-nav-link.activePage {
          color: #2575fc !important;
        }

        .hdr2-hamburger {
          background: rgba(0, 0, 0, 0.06);
          border: 1.5px solid rgba(0, 0, 0, 0.1);
          color: #374151;
          border-radius: 10px;
          width: 42px;
          height: 42px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 22px;
          cursor: pointer;
          transition: background 0.2s, border-color 0.2s;
        }
        .hdr2-hamburger:hover {
          background: rgba(37, 117, 252, 0.08);
          border-color: rgba(37, 117, 252, 0.3);
          color: #2575fc;
        }
      `}</style>

      <div className='overlay' />
      <div className={`side-overlay ${(menuActive || activeCategory) && "show"}`} />

      {/* Search Box Modal */}
      <form action='#' className={`search-box ${activeSearch && "active"}`}>
        <button
          onClick={handleSearchToggle}
          type='button'
          className='search-box__close position-absolute inset-block-start-0 inset-inline-end-0 m-16 w-48 h-48 border border-gray-100 rounded-circle flex-center text-white hover-text-gray-800 hover-bg-white text-2xl transition-1'
        >
          <i className='ph ph-x' />
        </button>
        <div className='container'>
          <div className='position-relative'>
            <input
              type='text'
              className='form-control py-16 px-24 text-xl rounded-pill pe-64'
              placeholder='Search for a product or brand'
            />
            <button
              type='submit'
              className='w-48 h-48 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8'
            >
              <i className='ph ph-magnifying-glass' />
            </button>
          </div>
        </div>
      </form>

      {/* Mobile Menu */}
      <div className={`mobile-menu scroll-sm d-lg-none d-block ${menuActive && "active"}`}>
        <button
          onClick={() => { handleMenuToggle(); setActiveIndex(null); }}
          type='button'
          className='close-button'
        >
          <i className='ph ph-x' />{" "}
        </button>
        <div className='mobile-menu__inner'>
          <Link to='/' className='mobile-menu__logo'>
            <img src='assets/images/logo/logo.png' alt='Logo' />
          </Link>
          <div className='mobile-menu__menu'>
            <ul className='nav-menu flex-align nav-menu--mobile'>
              <li
                onClick={() => handleMenuClick(0)}
                className={`on-hover-item nav-menu__item has-submenu ${activeIndex === 0 ? "d-block" : ""}`}
              >
                <Link to='#' className='nav-menu__link'>Home</Link>
              </li>
              <li
                onClick={() => handleMenuClick(1)}
                className={`on-hover-item nav-menu__item has-submenu ${activeIndex === 1 ? "d-block" : ""}`}
              >
                <Link to='#' className='nav-menu__link'>Shop</Link>
                <ul className={`on-hover-dropdown common-dropdown nav-submenu scroll-sm ${activeIndex === 1 ? "open" : ""}`}>
                  <li className='common-dropdown__item nav-submenu__item'>
                    <Link onClick={() => setActiveIndex(null)} to='/shop' className='common-dropdown__link nav-submenu__link hover-bg-neutral-100'>Shop</Link>
                  </li>
                  <li className='common-dropdown__item nav-submenu__item'>
                    <Link onClick={() => setActiveIndex(null)} to='/product-details-two' className='common-dropdown__link nav-submenu__link hover-bg-neutral-100'>Shop Details Two</Link>
                  </li>
                </ul>
              </li>
              <li
                onClick={() => handleMenuClick(3)}
                className={`on-hover-item nav-menu__item has-submenu ${activeIndex === 3 ? "d-block" : ""}`}
              >
                <Link to='#' className='nav-menu__link'>Vendors</Link>
                <ul className={`on-hover-dropdown common-dropdown nav-submenu scroll-sm ${activeIndex === 3 ? "open" : ""}`}>
                  <li className='common-dropdown__item nav-submenu__item'>
                    <Link onClick={() => setActiveIndex(null)} to='/vendor-two' className='common-dropdown__link nav-submenu__link hover-bg-neutral-100'>All Vendors</Link>
                  </li>
                  <li className='common-dropdown__item nav-submenu__item'>
                    <Link onClick={() => setActiveIndex(null)} to='/become-seller' className='common-dropdown__link nav-submenu__link hover-bg-neutral-100'>Why Be A Vendor</Link>
                  </li>
                  <li className='common-dropdown__item nav-submenu__item'>
                    <Link onClick={() => setActiveIndex(null)} to='/vendor-registration' className='common-dropdown__link nav-submenu__link hover-bg-neutral-100'>Vendor Registration</Link>
                  </li>
                  {isVendorAuthenticated && (
                    <li className='common-dropdown__item nav-submenu__item'>
                      <Link onClick={() => setActiveIndex(null)} to='/business-registration' className='common-dropdown__link nav-submenu__link hover-bg-neutral-100'>Business Registration</Link>
                    </li>
                  )}
                  {isVendorAuthenticated && vendor?.has_business && (
                    <li className='common-dropdown__item nav-submenu__item'>
                      <Link onClick={() => setActiveIndex(null)} to='/coupon-registration' className='common-dropdown__link nav-submenu__link hover-bg-neutral-100'>Create Coupon</Link>
                    </li>
                  )}
                </ul>
              </li>
              <li className='nav-menu__item'>
                <Link to='/tutorial' className='nav-menu__link'>Tutorial</Link>
              </li>
              <li className='nav-menu__item'>
                <Link to='/blog' className='nav-menu__link'>Blog</Link>
              </li>
              <li className='nav-menu__item'>
                <Link to='/contact' className='nav-menu__link'>Contact Us</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* ===== Top Bar ===== */}
      <header className='header-middle style-two hdr2-bar'>
        <div className='container container-lg'>
          <nav className='header-inner flex-between'>
            {/* Logo */}
            <div className='logo'>
              <Link to='/' className='link'>
                <img
                  src='/assets/images/logo/logo-header.png'
                  alt='Fun Card'
                  style={{ height: '75px', width: '250px', maxWidth: 'none', objectFit: 'fill', display: 'block' }}
                />
              </Link>
            </div>

            {/* Search Bar */}
            <div className='flex-align gap-16'>
              <form className='hdr2-search-pill d-sm-flex d-none' onSubmit={handleSearchSubmit}>
                <select
                  className='js-example-basic-single hdr2-cat-select'
                  value={searchCategory}
                  onChange={(e) => setSearchCategory(e.target.value)}
                >
                  <option value=''>All Categories</option>
                  <option value='Attractions'>Attractions</option>
                  <option value='Beer / Drinks'>Beer / Drinks</option>
                  <option value='Accommodations'>Accommodations</option>
                  <option value='Coffee Shops'>Coffee Shops</option>
                  <option value='Dining'>Dining</option>
                  <option value='Retail'>Retail</option>
                  <option value='Transportation'>Transportation</option>
                  <option value='Golf / Mini'>Golf / Mini</option>
                  <option value='Tours / Excursions'>Tours / Excursions</option>
                  <option value='Spa / Health'>Spa / Health</option>
                  <option value='Museums'>Museums</option>
                  <option value='Misc'>Misc</option>
                </select>
                <input
                  type='text'
                  className='hdr2-search-input'
                  placeholder='Search for a coupon or business...'
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                />
                <button type='submit' className='hdr2-search-btn'>
                  <i className='ph ph-magnifying-glass' />
                </button>
              </form>
            </div>

            {/* Right Icons */}
            <div className='header-right flex-align d-lg-block d-none'>
              <div className='header-two-activities flex-align flex-wrap gap-4'>
                <button
                  type='button'
                  className='hdr2-icon-btn search-icon d-lg-none d-flex'
                  onClick={handleSearchToggle}
                >
                  <span className='hdr2-icon-symbol'><i className='ph ph-magnifying-glass' /></span>
                </button>

                {!isVendorAuthenticated && (
                  <Link
                    to={isAuthenticated ? '/user-dashboard' : '/account-login'}
                    className='hdr2-icon-btn'
                  >
                    <span className='hdr2-icon-symbol'><i className='ph ph-user' /></span>
                    <span className='hdr2-icon-label'>
                      {isAuthenticated && user?.first_name ? `${user.first_name}'s Profile` : 'User Profile'}
                    </span>
                  </Link>
                )}

                {isVendorAuthenticated ? (
                  <Link to='/vendor-dashboard' className='hdr2-icon-btn'>
                    <span className='hdr2-icon-symbol'><i className='ph ph-storefront' /></span>
                    <span className='hdr2-icon-label'>Vendor Dashboard</span>
                  </Link>
                ) : !isAuthenticated ? (
                  <Link to='/vendor-login' className='hdr2-icon-btn'>
                    <span className='hdr2-icon-symbol'><i className='ph ph-storefront' /></span>
                    <span className='hdr2-icon-label'>Vendor Profile</span>
                  </Link>
                ) : null}

                {isAuthenticated && (
                  <button onClick={handleLogout} className='hdr2-icon-btn'>
                    <span className='hdr2-icon-symbol'><i className='ph ph-sign-out' /></span>
                    <span className='hdr2-icon-label'>Logout</span>
                  </button>
                )}
                {isVendorAuthenticated && (
                  <button onClick={handleLogoutVendor} className='hdr2-icon-btn'>
                    <span className='hdr2-icon-symbol'><i className='ph ph-sign-out' /></span>
                    <span className='hdr2-icon-label'>Logout</span>
                  </button>
                )}

                <Link to='/cart' className='hdr2-icon-btn'>
                  <div className='hdr2-cart-wrap'>
                    <span className='hdr2-icon-symbol'><i className='ph ph-shopping-cart-simple' /></span>
                    <span className='hdr2-cart-badge'>{cartCount}</span>
                  </div>
                  <span className='hdr2-icon-label'>Cart</span>
                </Link>
              </div>
            </div>
          </nav>
        </div>
      </header>

      {/* ===== Nav Bar ===== */}
      <header className={`header hdr2-nav-bar ${scroll && "fixed-header"}`}>
        <div className='container container-lg'>
          <nav className='header-inner d-flex justify-content-between gap-8'>
            <div className='flex-align menu-category-wrapper'>

              {/* Category Dropdown (category === false) */}
              <div className={`category-two ${category === false ? "d-block" : "d-none"}`}>
                <button
                  onClick={handleCategoryToggle}
                  type='button'
                  className='category__button flex-align gap-8 fw-medium bg-main-two-600 p-16 text-white'
                >
                  <span className='icon text-2xl d-xs-flex d-none'>
                    <i className='ph ph-dots-nine text-muted' />
                  </span>
                  <span className='d-sm-flex d-none text-muted'>All Categories</span>
                  <span className='arrow-icon text-xl d-flex'>
                    <i className='ph ph-caret-down text-muted' />
                  </span>
                </button>
                <div className={`responsive-dropdown cat common-dropdown d-lg-none d-block nav-submenu p-0 submenus-submenu-wrapper shadow-none border border-gray-100 ${activeCategory && "active"}`}>
                  <button
                    onClick={() => { handleCategoryToggle(); setActiveIndexCat(null); }}
                    type='button'
                    className='close-responsive-dropdown rounded-circle text-xl position-absolute inset-inline-end-0 inset-block-start-0 mt-4 me-8 d-lg-none d-flex'
                  >
                    <i className='ph ph-x' />{" "}
                  </button>
                  <div className='logo px-16 d-lg-none d-block'>
                    <Link to='/' className='link'>
                      <img src='/assets/images/logo/logo-header.png' alt='Logo' />
                    </Link>
                  </div>
                  <ul className='scroll-sm p-0 py-8 overflow-y-auto'>
                    {[
                        "Attractions",
                        "Beer / Drinks",
                        "Accommodations",
                        "Coffee Shops",
                        "Dining",
                        "Retail",
                        "Transportation",
                        "Golf / Mini",
                        "Tours / Excursions",
                        "Spa / Health",
                        "Museums",
                        "Misc",
                      ].map((item, i) => (
                      <li
                        key={i}
                        onClick={() => handleCatClick(i)}
                        className={`has-submenus-submenu ${activeIndexCat === i ? "active" : ""}`}
                      >
                        <Link
                          onClick={() => setActiveIndexCat(null)}
                          to=''
                          className='text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0'
                        >
                          <span>{item}</span>
                          <span className='icon text-md d-flex ms-auto'>
                            <i className='ph ph-caret-right' />
                          </span>
                        </Link>
                        <div className={`submenus-submenu py-16 ${activeIndexCat === i ? "open" : ""}`}>
                          <h6 className='text-lg px-16 submenus-submenu__title'>{item}</h6>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Purchase Fun Card button (category === true, hidden for vendors) */}
              {!isVendorAuthenticated && (
                <div className={`category main ${category === true ? "d-block" : "d-none"}`}>
                  <Link
                    to={isAuthenticated ? "/cart" : "/account-login"}
                    className='hdr2-purchase-btn'
                  >
                    <i className='ph ph-tag' style={{ fontSize: '17px' }} />
                    Purchase Fun Card
                  </Link>
                </div>
              )}

              {/* Desktop Nav Menu */}
              <div className='header-menu d-lg-block d-none'>
                <ul className='nav-menu flex-align'>
                  <li className='nav-menu__item'>
                    <NavLink
                      to='/'
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link hdr2-nav-link activePage"
                          : "nav-menu__link hdr2-nav-link"
                      }
                      onClick={() => setActiveIndex(null)}
                    >
                      Home
                    </NavLink>
                  </li>
                  <li className='nav-menu__item'>
                    <Link to='/shop' className='nav-menu__link hdr2-nav-link'>
                      Shop
                    </Link>
                  </li>
                  <li className='on-hover-item nav-menu__item has-submenu'>
                    <Link to='#' className='nav-menu__link hdr2-nav-link'>
                      Vendors
                    </Link>
                    <ul className='on-hover-dropdown common-dropdown nav-submenu scroll-sm'>
                      <li className='common-dropdown__item nav-submenu__item'>
                        <NavLink
                          to='/vendor-two'
                          className={(navData) =>
                            navData.isActive
                              ? "common-dropdown__link nav-submenu__link hover-bg-neutral-100 activePage"
                              : "common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                          }
                        >
                          All Vendors
                        </NavLink>
                      </li>
                      <li className='common-dropdown__item nav-submenu__item'>
                        <NavLink
                          to='/become-seller'
                          className={(navData) =>
                            navData.isActive
                              ? "common-dropdown__link nav-submenu__link hover-bg-neutral-100 activePage"
                              : "common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                          }
                        >
                          Why Be A Vendor
                        </NavLink>
                      </li>
                      <li className='common-dropdown__item nav-submenu__item'>
                        <NavLink
                          to='/vendor-registration'
                          className={(navData) =>
                            navData.isActive
                              ? "common-dropdown__link nav-submenu__link hover-bg-neutral-100 activePage"
                              : "common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                          }
                        >
                          Vendor Registration
                        </NavLink>
                      </li>
                      {isVendorAuthenticated && (
                        <li className='common-dropdown__item nav-submenu__item'>
                          <NavLink
                            to='/business-registration'
                            className={(navData) =>
                              navData.isActive
                                ? "common-dropdown__link nav-submenu__link hover-bg-neutral-100 activePage"
                                : "common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                            }
                          >
                            Business Registration
                          </NavLink>
                        </li>
                      )}
                      {isVendorAuthenticated && vendor?.has_business && (
                        <li className='common-dropdown__item nav-submenu__item'>
                          <NavLink
                            to='/coupon-registration'
                            className={(navData) =>
                              navData.isActive
                                ? "common-dropdown__link nav-submenu__link hover-bg-neutral-100 activePage"
                                : "common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                            }
                          >
                            Create Coupon
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  </li>
                  <li className='nav-menu__item'>
                    <NavLink to='/tutorial' className={(navData) => navData.isActive ? "nav-menu__link hdr2-nav-link activePage" : "nav-menu__link hdr2-nav-link"}>Tutorial</NavLink>
                  </li>
                  <li className='nav-menu__item'>
                    <NavLink to='/blog' className={(navData) => navData.isActive ? "nav-menu__link hdr2-nav-link activePage" : "nav-menu__link hdr2-nav-link"}>Blog</NavLink>
                  </li>
                  <li className='nav-menu__item'>
                    <NavLink
                      to='/contact'
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link hdr2-nav-link activePage"
                          : "nav-menu__link hdr2-nav-link"
                      }
                    >
                      Contact Us
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>

            {/* Mobile: icons + hamburger */}
            <div className='header-right flex-align'>
              <div className='me-8 d-lg-none d-block'>
                <div className='header-two-activities flex-align flex-wrap gap-16'>
                  <button
                    onClick={handleSearchToggle}
                    type='button'
                    className='flex-align gap-4'
                    style={{ background: 'none', border: 'none', color: '#374151', fontSize: '22px', cursor: 'pointer' }}
                  >
                    <i className='ph ph-magnifying-glass' />
                  </button>
                  <Link to='/account' style={{ color: '#374151', fontSize: '22px' }}>
                    <i className='ph ph-user' />
                  </Link>
                  <Link to='/cart' className='position-relative' style={{ color: '#374151', fontSize: '22px' }}>
                    <i className='ph ph-shopping-cart-simple' />
                    <span className='w-16 h-16 flex-center rounded-circle bg-main-two-600 text-white text-xs position-absolute top-n6 end-n4'>
                      {cartCount}
                    </span>
                  </Link>
                </div>
              </div>
              <button
                onClick={handleMenuToggle}
                type='button'
                className='hdr2-hamburger d-lg-none ms-3n'
              >
                <i className='ph ph-list' />
              </button>
            </div>
          </nav>
        </div>
      </header>
    </>
  );
};

export default HeaderTwo;
